import React from 'react';
import ReactDOM from 'react-dom';
import {onAppRegistered} from './resources/zendesk';

//@ts-ignore
import ZendeskClient from './zaf';
import AssignedLicenses from './components/view-assigned-license/AssignedLicenses';

function renderRoot(element: JSX.Element) {
    ReactDOM.render(element, document.getElementById('assigned-license-model'));
}

function initialise(module: any) {
    // @ts-ignore
    const client = initZendeskClient();
    if (client) {
        //eslint-disable-next-line
        (window as any)['ZendeskClient'] = client;
        onAppRegistered(function () {
            renderRoot(<AssignedLicenses/>);
        });
    } else {
        renderRoot(<h1>Problem loading app...</h1>);
    }
}

function initZendeskClient(): ZendeskClient | unknown {
    if (document.defaultView && (document.defaultView as never)['ZAFClient']) {
        return ((document.defaultView as never)['ZAFClient'] as typeof ZendeskClient).init();
    }
}

setTimeout(initialise, 500);